var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoDark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 177.721,
    height: 58.357,
    viewBox: "0 0 177.721 58.357",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6483",
    "data-name": "Group 6483",
    transform: "translate(-300.052 -444.65)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10598",
    "data-name": "Path 10598",
    d: "M567.195,444.919l16.848,29.17L601,444.919Z",
    transform: "translate(-250.295 -0.252)",
    fill: "#02022C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10599",
    "data-name": "Path 10599",
    d: "M834.338,474.089l16.96-29.17,17.164,29.17Z",
    transform: "translate(-500.59 -0.252)",
    fill: "#02022C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10600",
    "data-name": "Path 10600",
    d: "M300.052,474.089l16.848-29.17,16.848,29.17Z",
    transform: "translate(0 -0.252)",
    fill: "#02022C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10601",
    "data-name": "Path 10601",
    d: "M606.408,971.784l-1.9,3.345-1.249-2.368-.953,6.254-3.144,5.547h-1.184l3.1-20.651h1.18Z",
    transform: "translate(-279.141 -486.513)",
    fill: "#02022C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10602",
    "data-name": "Path 10602",
    d: "M333.752,907.436l-5.5,9.7-4.118-7.817H320.5l-3.6,24.009h2.181l-1.859,3.279-17.163-29.171Z",
    transform: "translate(-0.005 -433.599)",
    fill: "#02022C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10603",
    "data-name": "Path 10603",
    d: "M622.174,984.563h-3.481l-1.83-11.8-6.195,11.8h-1.18l-4.976-9.433-1.249-2.368-.953,6.254-.846,5.547h-3.481l3.1-20.651h1.18l4.148,7.873,3.67,6.967,7.818-14.84h1.18Z",
    transform: "translate(-279.141 -486.513)",
    fill: "#02022C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10604",
    "data-name": "Path 10604",
    d: "M619.076,963.912H617.9l-7.818,14.84-3.67-6.967-4.148-7.873h-1.18l-3.1,20.652h3.481l.846-5.548.953-6.253,1.249,2.367,4.976,9.434h1.18l6.195-11.8,1.83,11.8h3.481Z",
    transform: "translate(-279.141 -486.514)",
    fill: "#02022C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10605",
    "data-name": "Path 10605",
    d: "M1046.863,963.911v12.8a5.008,5.008,0,0,0,.413,2.109,4.487,4.487,0,0,0,1.092,1.5,4.442,4.442,0,0,0,1.549.9,5.414,5.414,0,0,0,3.526,0,4.437,4.437,0,0,0,2.626-2.4,5.016,5.016,0,0,0,.413-2.109v-12.8h3.54v12.8a9.025,9.025,0,0,1-.723,3.732,8.153,8.153,0,0,1-1.888,2.685,7.632,7.632,0,0,1-2.67,1.608,9.131,9.131,0,0,1-6.137,0,7.628,7.628,0,0,1-2.67-1.608,8.133,8.133,0,0,1-1.888-2.685,9.021,9.021,0,0,1-.723-3.732v-6.638l3.541-2.862h-3.541v-3.3Z",
    transform: "translate(-696.394 -486.513)",
    fill: "#02022C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10606",
    "data-name": "Path 10606",
    d: "M1651.607,970.076v14.486h3.54V967.214Zm-6.7-6.166v3.3h14.045l2.948-3.243v-.061Z",
    transform: "translate(-1260.042 -486.512)",
    fill: "#02022C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10607",
    "data-name": "Path 10607",
    d: "M1954.738,970.076v14.486h3.54V967.214Zm-6.7-6.166v.025h.03l3.051,3.279h13.913v-3.3Z",
    transform: "translate(-1544.054 -486.512)",
    fill: "#02022C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10608",
    "data-name": "Path 10608",
    d: "M2269.884,963.911h13.365v3.3h-9.824v5.37h7.7v3.3h-7.7v5.369h9.824v3.3h-13.365V970.077l3.541-2.862h-3.541Z",
    transform: "translate(-1845.6 -486.513)",
    fill: "#02022C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10609",
    "data-name": "Path 10609",
    d: "M2533.228,976.337a9.5,9.5,0,0,1-2.7,1.563,10,10,0,0,1-3.467.531,11.368,11.368,0,0,1-4.012-.664,9.875,9.875,0,0,1-3.068-1.8,9.723,9.723,0,0,1-2.124-2.626,11.3,11.3,0,0,1-1.18-3.157,12.147,12.147,0,0,1-.236-3.378,11.759,11.759,0,0,1,.708-3.3h4.13a7.151,7.151,0,0,0-.958,2.316,8.321,8.321,0,0,0,.413,4.986,6.671,6.671,0,0,0,1.357,2.109,6.411,6.411,0,0,0,2.124,1.46,7.136,7.136,0,0,0,2.876.546,7.4,7.4,0,0,0,1.475-.133,5.648,5.648,0,0,0,2.006-.811,3.881,3.881,0,0,0,.591-.472Zm-14.369-15.843a9.787,9.787,0,0,1,3.378-2.611,11,11,0,0,1,4.823-.988,9.959,9.959,0,0,1,3.246.546,10.429,10.429,0,0,1,2.921,1.549l-2.065,2.891a5.958,5.958,0,0,0-1.7-1.033,6.057,6.057,0,0,0-2.375-.442,6.917,6.917,0,0,0-3.392.782,6.443,6.443,0,0,0-2.272,2.05Z",
    transform: "translate(-2076.579 -479.938)",
    fill: "#02022C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10610",
    "data-name": "Path 10610",
    d: "M2849.485,963.911h3.54v8.674h9.854v-8.674h3.541v20.652h-3.541v-8.674h-9.854v8.674h-3.54V978.78l3.54-2.891h-3.54Z",
    transform: "translate(-2388.647 -486.513)",
    fill: "#02022C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10611",
    "data-name": "Path 10611",
    d: "M1278.313,471.442a2.519,2.519,0,0,0-2.506,2.291l-61.488-.1-17.232-28.981h-4.947l17.049,29.417h2.479v0l64.137.106a2.517,2.517,0,1,0,2.508-2.733Zm0,4.593a2.076,2.076,0,1,1,2.076-2.076A2.078,2.078,0,0,1,1278.313,476.035Z",
    transform: "translate(-835.827 0)",
    fill: "#02022C"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6481",
    "data-name": "Group 6481",
    transform: "translate(447.56 479.938)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10612",
    "data-name": "Path 10612",
    d: "M2642.883,1072.931a3.937,3.937,0,1,1,3.937-3.937A3.942,3.942,0,0,1,2642.883,1072.931Zm0-7.244a3.306,3.306,0,1,0,3.306,3.307A3.31,3.31,0,0,0,2642.883,1065.687Z",
    transform: "translate(-2638.945 -1061.217)",
    fill: "#02022C"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_158",
    "data-name": "Rectangle 158",
    width: 6.603,
    height: 0.631,
    transform: "translate(6.536 5.423) rotate(-55.214)",
    fill: "#02022C"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_159",
    "data-name": "Rectangle 159",
    width: 0.631,
    height: 6.603,
    transform: "matrix(0.801, -0.599, 0.599, 0.801, 6.362, 10.594)",
    fill: "#02022C"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6482",
    "data-name": "Group 6482",
    transform: "translate(367.226 476.543)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10613",
    "data-name": "Path 10613",
    d: "M1369.5,957.367a3.459,3.459,0,0,0,1.4,1.151q.988.5,2.242,1t2.582,1.077a11.657,11.657,0,0,1,2.434,1.416,7.507,7.507,0,0,1,1.829,1.992,5.168,5.168,0,0,1,.723,2.8,4.895,4.895,0,0,1-.679,2.611,6.109,6.109,0,0,1-1.741,1.844,7.543,7.543,0,0,1-2.4,1.092,10.442,10.442,0,0,1-2.67.354,12.784,12.784,0,0,1-2.286-.207,10.332,10.332,0,0,1-2.183-.649,9.428,9.428,0,0,1-1.962-1.121,7.92,7.92,0,0,1-1.623-1.623l2.744-2.154a4.95,4.95,0,0,0,2.434,1.785,9.4,9.4,0,0,0,2.994.487,7.455,7.455,0,0,0,1.269-.118,4.568,4.568,0,0,0,1.268-.413,2.83,2.83,0,0,0,.974-.782,1.919,1.919,0,0,0,.383-1.224,2.054,2.054,0,0,0-.767-1.608,8.282,8.282,0,0,0-1.947-1.21q-1.181-.545-2.582-1.092a20.118,20.118,0,0,1-2.67-1.268,9.609,9.609,0,0,1-2.213-1.711,4.651,4.651,0,0,1-1.21-2.434Zm-3.451-2.921a5.386,5.386,0,0,1,1.018-1.8,5.9,5.9,0,0,1,1.578-1.283,7.518,7.518,0,0,1,1.977-.767,9.611,9.611,0,0,1,2.213-.251,9.95,9.95,0,0,1,3.939.811,10.424,10.424,0,0,1,3.319,2.227l-2.33,2.6a7.51,7.51,0,0,0-2.316-1.593,6.746,6.746,0,0,0-2.729-.56,6.166,6.166,0,0,0-1.3.133,3.351,3.351,0,0,0-1.107.443,2.332,2.332,0,0,0-.782.826,2.548,2.548,0,0,0-.3,1.283,1.236,1.236,0,0,0,.118.561Z",
    transform: "translate(-1365.167 -950.345)",
    fill: "#02022C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10614",
    "data-name": "Path 10614",
    d: "M1554.007,964.3l-6.1,5.83,1.413-1.679,2.032-2.032Z",
    transform: "translate(-1536.386 -963.423)",
    fill: "#02022C"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoDark);
export default __webpack_public_path__ + "static/media/logo-dark.cea8cd181b379adeb818530850426d89.svg";
export { ForwardRef as ReactComponent };